import { createSlice } from '@reduxjs/toolkit';
// @types
import { options } from '../../../@types/categories/categories';
import { useDispatch, } from '../../store'
import { get, post, put } from '../api/api'

import { dispatch } from '../../store';

// ----------------------------------------------------------------------

type ageGroupState = {
  isLoading: boolean,
  error: Error | string | null;
  ageGroupGroupOptions: options[];
};

const initialState: ageGroupState = {
  isLoading: true,
  error: null,
  ageGroupGroupOptions: []
};

const slice = createSlice({
  name: 'ageGroupGroup',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getAgeGroupGroupsOptionsSuccess(state, action){
      state.isLoading = false;
      state.ageGroupGroupOptions = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;

export function getAgeGroupGroupsOptions() {
  return async () => {
    try {
      var ageGroupGroup = await get('/options/all?options=ageGroupGroup')
      var options: options[] = [];
      ageGroupGroup.data.ageGroupGroup.forEach((group: any) =>{
        if(group.status === 'active'){
          options.push({value: group._id, label: group.title})
        }
      })
      options.sort(function(a, b){
        if(a.label.toUpperCase() < b.label.toUpperCase()) { return -1; }
        if(a.label.toUpperCase() > b.label.toUpperCase()) { return 1; }
        return 0;
      })
      dispatch(slice.actions.getAgeGroupGroupsOptionsSuccess(options));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createOrUpdateAgeGroupGroup(ageGroup: {_id?: string, title?: string, status?: string}) {
  return async () => {
    try {
      await put('/options/ageGroupGroup', ageGroup)
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}